import { useCallback } from 'react';

import { DeviceInfo } from '../../deviceInfo/deviceInfo';
import { fetchStatsConfigAction } from '../apiActions/fetchStatsConfigAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';
import { configActions } from '../slices/config/slice';

export const useStatsConfigFetcher = (): (() => void) => {
  const dispatch = useCoreDispatch();
  const env = useConfigSlice.env();
  const settings = useConfigSlice.statsSettings();
  const videoConfig = useConfigSlice.videoConfig();
  const isIOS = DeviceInfo.getPlatform().IS_IOS;
  return useCallback(() => {
    if (!env || settings === undefined) return;
    const nonIosVideoPlayerVersion = videoConfig?.videoPlayerVersion ?? 3; // Default to 3 if not defined
    // For iOS, we always allow fetching stats config
    // For non-iOS, we allow fetching if the video player version is 3 or higher
    const allowedToFetchIpBasedStatsConfig = isIOS || nonIosVideoPlayerVersion >= 3;
    const baseUrl = env.statsCollector;
    if (baseUrl && settings && allowedToFetchIpBasedStatsConfig) {
      dispatch(
        fetchStatsConfigAction({
          url: `${baseUrl}`,
          ipAddress: settings.ipAddress,
        })
      );
    } else {
      // Explicitly dispatch null, meaning config is not available
      dispatch(configActions.setStatsConfig(null));
    }
  }, [dispatch, env, settings, isIOS, videoConfig]);
};
